import { Box, Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import React, { useState } from "react";
import CustomTypography from "../../../../components/common/CustomTypography";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";
import { usePromotionOnboardingTracking } from "../../../../hooks/usePromotionOnboardingTracking";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

interface SelectOption {
  id: number;
  label: string;
}

export const selectOptionList: SelectOption[] = [
  { id: 1, label: "근본 원인을 해결하는 것" },
  { id: 2, label: "신속하게 증상을 잡는 것" },
  { id: 3, label: "잘 모르겠음" },
];

export default function Approach_6_Promotion({
  version = "v4",
}: {
  version?: MktVersionTypes;
}) {
  const [isAnimating, setIsAnimating] = useState(false);

  const pageKey = "approach_6";

  const { singleSelectionId, updateSingleSelection, handleNext } =
    useOnboardingPromotionPage({
      pageKey,
      nextPageRoute: `/${versionToPathPrefix(version)}-onboarding/approach/7`,
    });

  const { trackSingleSelection } = usePromotionOnboardingTracking(pageKey, version);

  const handleOptionChange = (optionId: number) => {
    updateSingleSelection(optionId);
    trackSingleSelection(optionId);

    setTimeout(() => {
      setIsAnimating(false);
      handleNext({ singleSelectionId: optionId });
    }, 300);
  };

  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <Stack spacing={2}>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{ color: theme.vars.palette.Content.Strong }}
        >
          {"나에게 맞는 이상적인 심리치료는 무엇이라고 생각하나요?"}
        </CustomTypography>
      </Stack>

      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            whiteSpace: "nowrap",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {selectOptionList.map(({ id, label }) => (
            <Stack key={`select_option_${id}`} sx={{ flexGrow: 1, gap: 1 }}>
              <Button
                fullWidth
                variant={"SingleSlim"}
                size={"lg"}
                color={singleSelectionId === id ? "primary" : "secondary"}
                sx={{
                  transition: "background-color 0.3s ease",
                }}
                onClick={() => {
                  handleOptionChange(id);
                }}
              >
                {label}
              </Button>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
